<div class="row">
     <div class="col-12">
       <div class="row justify-content-between align-items-center" id="page-title">
         <h1
           class="progress-header col-12 col-lg-auto"
           [innerHTML]="'Enroll in PSP_MAIN' | translator:'base'"
         >
           Enroll in PSP
         </h1>
       </div>
       <div class="row mb-2">
         <span class="col-12 col-lg-auto d-flex align-items-center small">
           <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
           <span [innerHTML]="'Start_8-1' | translator:'base'">
             Are you a <strong>driver</strong> looking for your own PSP record?
           </span>
           <a
             routerLink="/driver/1"
             (click)="scrollToTop()"
             name="Driver-record-request"
             id="Driver-record-request"
             [title]="'Start_8-2' | translator:'base'"
             class="ms-1" 
           >
             <span [innerHTML]="'Start_8-2' | translator:'base'">Access your PSP record here.</span>
           </a>
         </span>
       </div>
       <div class="row">
         <div class="col-lg-8">
           <div class="card shadow-sm rounded-0 border-0">
             <div class="card-body">
               <app-complete-bar  [step]="2" [totalSteps]="19"></app-complete-bar >
               <h2 [innerHTML]="'NotSure_1' | translator:'base'">Not sure? No problem!</h2>
               <p class="step-text" [innerHTML]="'NotSure_2' | translator:'base'">
                 Please contact the PSP customer service team for assistance enrolling in the program.
               </p>
               <hr />
               <p [innerHTML]="'NotSure_3' | translator:'base'">
                 You may contact them by phone: 1-877-642-9499 (toll free)
               </p>
               <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                 <div class="btn-group" role="group"></div>
                 <div class="btn-group" role="group">
                   <a
                     routerLink="/signup/1"
                     class="btn btn-outline-primary"
                     type="button"
                     (click)="scrollToTop()"
                     [title]="'NotSureTitle' | translator:'base'"
                     name="notSure"
                     id="notSure"
                   >
                     <span [innerHTML]="'Back' | translator:'base'"></span>
                   </a>
                   <a
                     routerLink="/"
                     class="btn btn-light"
                     (click)="scrollToTop()"
                     name="companyCancel4"
                     id="companyCancel4"
                     [innerHTML]="'Cancel' | translator:'base'"
                     [title]="'Cancel' | translator:'base'"
                   ></a>
                 </div>
               </div>
             </div>
           </div>
         </div>
         <app-progress-wizard  [wizardObj]="wizardObj" [activeStep]="2" pageType="-" class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard >
       </div>
     </div>
   </div>
   
